export const EVENT_AUTOCOMPLETE_LIST_HEADER_LABEL =
  "Liste d'évènements disponibles";
export const ARTICLE_ENHANCEMENT_EVENTS_TITLE = 'Évènements';
export const NO_ARTICLE_EVENT_SELECTED_TITLE = 'Aucun évènement de selectionné';
export const EVENT_SEARCH_BAR_PLACEHOLDER = 'Rechercher un évènement';
